export class DateUtil {
  /**
   * Formats an expiration date.
   * If it's a string, extracts the YYYY-MM-DD part.
   * If it's a Date, converts it to YYYY-MM-DD format.
   * If it's null, returns "N/A".
   * @param expirationDate - The expiration date (Date | string | null)
   * @returns A formatted string (YYYY-MM-DD or "N/A")
   */
  public static formattedExpirationDate(expirationDate: Date | null | string): string {
    if (!expirationDate) {
      return "N/A";
    }

    if (typeof expirationDate === "string") {
      return expirationDate.split("T")[0]; // Extract YYYY-MM-DD from ISO string
    }

    if (expirationDate instanceof Date) {
      return expirationDate.toISOString().split("T")[0]; // Convert Date to YYYY-MM-DD
    }

    return "Invalid Date"; // Fallback for unexpected input
  }
}
